// src/app/builderio/custom-components/DynamicMap/DynamicMap.tsx

import React from 'react';
import { AdvancedMarker, APIProvider, Map } from '@vis.gl/react-google-maps';
import bluePinImg from '../../../../img/pin-blue.png';

interface DynamicMapProps {
  latitude: number;
  longitude: number;
  zoom?: number;
  height?: number;
}

const DynamicMap: React.FC<DynamicMapProps> = ({
  latitude,
  longitude,
  zoom = 10,
  height = 400,
}) => {

  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ""}>
      <div style={{ width: '100%', height: height + "px" }}>
        <Map
          mapId={"BRANCH_MAP_WAREHOUSE_DIALOG"}
          defaultCenter={{ lat: latitude, lng: longitude }}
          gestureHandling={'cooperative'}
          defaultZoom={zoom}
          style={{ width: '100%', height: '100%' }}
          mapTypeControl={false}
        >
          <AdvancedMarker 
            key={longitude + latitude} 
            position={{ lat: latitude, lng: longitude }}>
            <img
              src={bluePinImg}
              alt="Map Pin"
              style={{ width: "50px", height: "50px", cursor: "pointer" }}
            />
          </AdvancedMarker>
        </Map>
      </div>
    </APIProvider>
  );
};

export const dynamicMapRegistration = {
  name: 'Dynamic Map',
  inputs: [
    {
      name: 'latitude',
      type: 'number',
    },
    {
      name: 'longitude',
      type: 'number',
    },
    {
      name: 'zoom',
      type: 'number',
      defaultValue: 10,
    },
    {
      name: 'height',
      type: 'number',
      defaultValue: 400,
    },
  ],
  image:
    'https://cdn-icons-png.flaticon.com/512/854/854878.png',
  description: 'Interactive Google Map (click, zoom, scroll)',
};

export default DynamicMap;
